var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.bunch.option)?_c('span',[_vm._v(" "+_vm._s(_vm.$options.methods.formatEmptyString(_vm.props.bunch.option.name, _vm.props.bunch.option.id))+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$options.methods.formatEmptyString(null))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }